module.exports = __webpack_public_path__ + "static/img/coupon_received3@3x.596f826e.png";